import { render, staticRenderFns } from "./GlossTextSearchInput.vue?vue&type=template&id=78758820&"
import script from "./GlossTextSearchInput.vue?vue&type=script&lang=ts&"
export * from "./GlossTextSearchInput.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports